<template>
  <div class="flatfinder-filter-type-range">
    <div class="flatfinder-filter-type-range__header">
      <label>
        <span>{{ label }}</span>
        <FontAwesomeIcon :icon="$attrs.icon" class="ml-1" />
      </label>
      <slot name="remove"></slot>
    </div>
    <div class="flatfinder-filter-type-range__value">
      <RangeSlider
        :min="min"
        :max="max"
        :type="type"
        :suffix="suffix"
        :step="step"
        @input="values => $emit('input', values)"
        :value="value"
      />
    </div>
  </div>
</template>

<script>
import RangeSlider from '../RangeSlider.vue'

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    min: Number,
    max: Number,
    label: String,
    suffix: String,
    step: Number,
    type: String,
  },
  components: {
    RangeSlider,
  },
}
</script>
<style lang="scss">
.flatfinder-filter-type-range {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    font-size: 0.8em;
    margin-bottom: 0.25rem;
  }

  &__value {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .elder-input__element,
  .elder-input__suffix {
    padding: 0.1em 0.25em;
    color: rgba(black, 0.6);
    background-color: rgba(white, 0.5);
  }

  .elder-input__suffix {
    font-size: 0.8em;
    display: flex;
    align-items: center;
  }

  .elder-input__field {
    background-color: rgba(white, 0.4);
  }
}
</style>
